module.exports = __webpack_public_path__ + "img/418-c06f1e.png";